import { createSlice } from "@reduxjs/toolkit";

export const alarmdata = createSlice({
    name: 'alarmdata',
    initialState: {
        livealarmarray: [],
        lastalarm: '',
        alarmaudiostate: {
            enableAudioForHighest: false,
            enableAudioForHigh: false,
            enableAudioForMedium: false,
            enableAudioForLow: false
        },
        selectedNodes: [],
    },
    reducers: {
        updatealarmarray: (state, alarmarray) => {
            state.livealarmarray = alarmarray.payload
        },
        updatelatestalarm: (state, newalarm) => {
            state.lastalarm = newalarm.payload
        },
        updatealarmaudiostate: (state, audiostate) => {
            state.alarmaudiostate = audiostate.payload   
        },
        updateSelectedNodes: (state, selectedNodes) => {
            state.selectedNodes = selectedNodes.payload;
        }
    }
})


export const {updatealarmarray, updatelatestalarm,updatealarmaudiostate, updateSelectedNodes} = alarmdata.actions
export default alarmdata.reducer